import Flatpickr from "stimulus-flatpickr"
import "flatpickr/dist/themes/dark.css"

export default class FlatpickrTimeController extends Flatpickr {
  connect() {
    this.config = {
      ...this.config, //spread options in case some where defined in initialize
      enableTime: true,
      noCalendar: true,
      dateFormat: "h:i K",
      position: "auto center"
    };

    super.connect();
  }
}
